/**
 * Établissements : données statiques du répertoire du MSSS, figées dans le
 * bundle par scripts/build_app_data.py.
 *
 * Le fichier stocke des tableaux plutôt que des objets, pour ne pas répéter
 * 9 noms de champs sur 816 entrées ; c'est ici qu'on leur redonne un nom.
 */

import payload from './establishments.json'

/**
 * L'`id` est l'index dans le GeoJSON trié, et sert de clé étrangère aux tables
 * Supabase. Les GMF et les hôpitaux numérotent chacun à partir de 0 : `kind`
 * fait donc partie de l'identité, jamais l'`id` seul.
 */
function expand(row, fields, kind) {
  const est = { kind }
  fields.forEach((name, i) => {
    est[name] = row[i]
  })
  return est
}

const gmf = payload.gmf.map((row) => expand(row, payload.gmfFields, 'gmf'))
const hosp = payload.hosp.map((row) => expand(row, payload.hospFields, 'hosp'))

export const establishments = [...gmf, ...hosp]

export const counts = {
  gmf: gmf.length,
  gmfu: gmf.filter((e) => e.type === 'GMF-U').length,
  hosp: hosp.length,
}

export const dataSource = payload.source

/** Convention d'identifiant, reportée dans les exports pour qu'ils restent lisibles plus tard. */
export const idScheme = payload.idScheme

/**
 * GeoJSON attendu par MapLibre. Le statut vient de l'état, pas des données
 * statiques.
 *
 * @param statusFor  (est) -> statut à peindre. Un GMF rend le sien ; un hôpital
 *   n'en a pas et rend celui de sa relation la plus avancée — voir
 *   domain/entities.js.
 */
export function toFeatureCollection(list, statusFor, hasDataFor) {
  return {
    type: 'FeatureCollection',
    features: list.map((est) => ({
      type: 'Feature',
      id: est.id,
      geometry: { type: 'Point', coordinates: [est.lon, est.lat] },
      properties: {
        id: est.id,
        nom: est.nom,
        mun: est.mun,
        type: est.type || 'HOSP',
        status: statusFor(est),
        annotated: hasDataFor(est),
      },
    })),
  }
}
